import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Quote } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { Crypto } from '../entities/crypto.model';
import { ETPListItem } from '../entities/etp.model';
import { ETPs } from './etps';

@Injectable({ providedIn: 'root' })
export class CryptoInfrastructure {
  private readonly endpoint = environment.apihost;

  constructor(private http: HttpClient) {}

  public getCryptos(): Observable<Crypto[]> {
    return this.http.get<Crypto[]>(`${this.endpoint}/api/instrument/kryptos`);
  }

  public getETPs(): Observable<ETPListItem[]> {
    return of(ETPs.get());
  }

  public getHistoryQuotes(isins: string[]): Observable<Record<string, Quote>> {
    return this.http.get<Record<string, Quote>>(`${this.endpoint}/api/quote/prev?isins=${isins}`);
  }
}
